"use client"

import { useToast } from "./use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={5000}>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const isError = variant === "destructive" || (title && title.toLowerCase().includes("error"));
        const isSuccess = title && title.toLowerCase().includes("success");

        return (
          <Toast
            className={`${isError
              ? "bg-red-800 border-red-800 text-white"
              : isSuccess
                ? "bg-green-800 border-green-800 text-white"
                : "bg-white border-gray-200 text-gray-900"
              }`}
            key={id}
            {...props}
          >
            <div className="grid gap-1">
              {title && (
                <ToastTitle
                  className={`${(isSuccess || isError) ? "text-white" : "text-gray-900"}`}
                >
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription
                  className={`${(isSuccess || isError) ? "text-white/90" : "text-gray-500"}`}
                >
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose
              className={`${(isSuccess || isError) ? "text-white hover:text-white/80" : "text-gray-500 hover:text-gray-900"}`}
            />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
